
// BoatHouseRenter.js

import React from 'react';
import '../../styles/products/BoatHouseRenter.css';

import { BsQrCode } from 'react-icons/bs';
import { SiGoogleforms } from "react-icons/si";
import { LuMessageSquareMore } from "react-icons/lu";
import renterplaceholder from '../../images/products/boathouserenter/renterFormIphoneFrame.png';

import Logo from '../design/Logo';
import TitleField from '../text/TitleField';
import TextField from '../text/TextField';
import FeatureCard from '../design/FeatureCard';

import { useMediaQuery } from '../../hooks/useMediaQuery';

const product = {
    name: 'Boathouse Renter App',
    overview: 'Residents scan a QR code, submit a rental request, and receive a text when their watercraft is ready.',
    visual: renterplaceholder,
    orientation: 'portrait',
    features: [
        {
            title: 'QR Access',
            description: 'Scan and instantly access the rental request form.',
            icon: BsQrCode,
        },
        {
            title: 'Guided Booking',
            description: 'Simple, step-by-step rental submission.',
            icon: SiGoogleforms,
        },
        {
            title: 'Text Alerts',
            description: 'Get notified by text when your watercraft is ready.',
            icon: LuMessageSquareMore,
        },
    ],
};

const BoatHouseRenter = () => {
    // Mobile and the "iPad display" range (see BoatHouseRenter.css) both
    // show feature cards in landscape style (icon beside text) regardless
    // of this product's own desktop orientation — the iPad range further
    // picks up the ipad-tuned landscape design from FeatureCard.css.
    const isMobileViewport = useMediaQuery('(max-width: 767px)');
    const isIpadCardViewport = useMediaQuery('(min-width: 768px) and (max-width: 912px)');
    const featureOrientation = (isMobileViewport || isIpadCardViewport) ? 'landscape' : product.orientation;

    return (
        <section id="boathouse-renter-app" className="product-showcase-container product-boathouse-renter-app-showcase-container">

            <div className="product-showcase-info-container product-boathouse-renter-app-showcase-info-container">
                <div className="product-showcase-logo-container product-boathouse-renter-app-showcase-logo-container">
                    <Logo variant="full" size="small" mode="light" />
                </div>
                <div className="product-showcase-title-container product-boathouse-renter-app-showcase-title-container">
                    <TitleField title={product.name} level={2} bold={true} fontSize='2.4rem' />
                </div>
                <div className="product-showcase-overview-container product-boathouse-renter-app-showcase-overview-container">
                    <TextField text={product.overview} fontColor="#666666" fontSize='1.1rem' />
                </div>
                <div className="product-feature-container product-boathouse-renter-app-feature-container">
                    <FeatureCard title={product.features[0].title} description={product.features[0].description} icon={product.features[0].icon} orientation={featureOrientation} />
                    <FeatureCard title={product.features[1].title} description={product.features[1].description} icon={product.features[1].icon} orientation={featureOrientation} />
                    <FeatureCard title={product.features[2].title} description={product.features[2].description} icon={product.features[2].icon} orientation={featureOrientation} />
                </div>
            </div>
            <div className="product-visual-container product-boathouse-renter-app-visual-container">
                <div className="product-visual product-boathouse-renter-app-visual">
                    <img 
                        className="product-visual-image product-boathouse-renter-app-visual-image" 
                        src={product.visual} 
                        alt={`${product.name} preview`}
                        draggable={false} />
                </div>
            </div>
        </section>
    );
};

export default BoatHouseRenter;
